export const escapeDoubleQuotes = (text: string | undefined) =>
  (text || '').replace(/["\\]/g, '\\$&');
